export const Days = [
    { id: 0, name: "S", fullName: "Sunday", short:'Sun' },
    { id: 1, name: "M", fullName: "Monday" , short:'Mon'},
    { id: 2, name: "T", fullName: "Tuesday", short:'Tue' },
    { id: 3, name: "W", fullName: "Wednesday", short:'Wed' },
    { id: 4, name: "T", fullName: "Thursday", short:'Thu' },
    { id: 5, name: "F", fullName: "Friday", short:'Fri' },
    { id: 6, name: "S", fullName: "Saturday", short:'Sat' },
  ];